export default {"src":"/_next/static/media/bell-icon.ec59a709.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};